import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import DepartmentList from "./DepartmentList";
import DepartmentCreate from "./DepartmentCreate";
import ProtectedRoutes from "components/common/routing/ProtectedRoutes";

const DepartmentsIndex = () => {
  return (
    <Routes>
      <Route index element={
        <ProtectedRoutes permissionKey="Department-view">
          <DepartmentList />
        </ProtectedRoutes>
      } />

      <Route path="create" element={
        <ProtectedRoutes permissionKey="Department-manage">
          <DepartmentCreate />
        </ProtectedRoutes>
      } />
      <Route path="*" element={<Navigate to="." />} />
    </Routes>
  );
};

export default DepartmentsIndex;
